Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-review-stars', function (envelope) {

        var $context = envelope.message.data.context,
            $stars = $('.x-review-stars[data-type="stars"]', $context);

        if ($stars.length < 1) return;

        $stars.each(function (i, star) {
            var $wrapper = $(star);

            var isRateMode = $wrapper.data('is-rate-mode');
            var ratingSummaryData = $wrapper.data('rating-summary');
            var ratingSummary = 0.00;

            if (typeof ratingSummaryData === 'string') {
                ratingSummary = parseFloat(ratingSummaryData.replace(",", "."));
            } else if (typeof ratingSummaryData === 'number') {
                ratingSummary = parseFloat(ratingSummaryData);
            }

            initStars(isRateMode, ratingSummary, $wrapper);
        });

    });

});

function initStars(isRateMode, ratingSummary, $wrapper) {

    var $stars = $wrapper.find('.star');
    var $starsList = $stars.closest('.star-list');
    var $rateSpan = $('.rate', $wrapper);
    var dataMember = $wrapper.data('member');

    if (isRateMode) {

        var $rateInput = $wrapper.parent().find('input[data-member="' + dataMember + '"]');

        var $clearBtn = $('input[data-click="clear-stars"]', $wrapper);

        $clearBtn.click(function () {
            $stars.removeClass('active selected');

            ratingSummary = 0;
            $rateSpan.text(ratingSummary);

            if ($rateInput.length > 0) {
                $rateInput.val('');
                $rateInput.keyup();
            }

            $clearBtn.hide();
        });

        $stars.mouseenter(function () {
            $stars.addClass('inactive');
            $(this).parent().nextAll().children().removeClass('active');
            $(this).parent().prevAll().children().addClass('active');
            $(this).addClass('active').prev().addClass('active');

            $rateSpan.text($('.star.active', $wrapper).length / 2);
        });

        $stars.mouseleave(function () {
            fillRatedStars(ratingSummary, $stars, false);
        });

        $stars.click(function () {
            //set clicked
            ratingSummary = $('.star.active', $wrapper).length / 2;

            fillRatedStars(ratingSummary, $stars, true);

            if ($rateInput.length > 0) {
                $rateInput.val($('.star.selected', $wrapper).length / 2);
                $rateInput.keyup();
            }
            $clearBtn.show();
        });

        $starsList.mouseleave(function () {
            $stars.removeClass('active inactive');
            $rateSpan.text($('.star.selected', $wrapper).length / 2);
        });

    } else {
        fillRatedStars(ratingSummary, $stars, true);
    }
}

function fillRatedStars(ratingSummary, $stars, isSelection) {
    if (isSelection) {
        $stars.removeClass('selected');
    }
    $stars.removeClass('active').addClass('inactive');

    var activeStars = 2 * (Math.floor(ratingSummary));

    var starsDecimal = Math.round((ratingSummary % 1) * 100);

    for (var i = 0; i < activeStars; i++) {
        $stars.eq(i).addClass('active').removeClass('inactive');
        if (isSelection) $stars.eq(i).addClass('selected');
    }

    if (starsDecimal == 50) {
        starsDecimal += 5;
        $stars.eq(i).css('width', starsDecimal + '%').addClass('active').removeClass('inactive');
        if (isSelection) $stars.eq(i).addClass('selected');
    }
};